export default __webpack_public_path__ + "static/media/Group 3870@2x.77442402.png";